// extracted by mini-css-extract-plugin
export default {"titleContainer":"exportedDocumentListPage_titleContainer__dQ5i6","descContainer":"exportedDocumentListPage_descContainer__F5+KG"};